import ProductPageDesktop from './product-page-desktop';

export default ProductPageDesktop;